import { ControllerContext } from "../controller";

/**
 * Online gameplay menu context
 * - START and B close the current menu and return to the previous context
 * - A activates the currently selected menu item
 * - Up/Down move the selection
 */
export const onlineGameplayMenuContext: ControllerContext = {
  start: {
    onDown: (_e, ctx) => {
      const top = ctx.menuManager.topMenu;
      if (top) {
        ctx.menuManager.closeMenu(top);
      }
      ctx.controller.popContext();
    },
  },
  actionA: {
    onDown: (_e, ctx) => {
      ctx.menuManager.activate(ctx);
    },
  },
  actionB: {
    onDown: (_e, ctx) => {
      const top = ctx.menuManager.topMenu;
      if (top) {
        ctx.menuManager.closeMenu(top);
      }
      ctx.controller.popContext();
    },
  },
  up: {
    onDown: (_e, ctx) => {
      ctx.menuManager.up();
    },
  },
  down: {
    onDown: (_e, ctx) => {
      ctx.menuManager.down();
    },
  },
};
